import React from 'react';
import { Table, Tag } from 'antd';
import type { ColumnsType } from 'antd/es/table';
import { useNavigate, useParams } from 'react-router-dom';

interface TeacherData {
  key: string;
  no: number;
  teacherId: string;
  name: string;
  birthDate: string;
  status: 'normal' | 'withdrawn';
  registrationDate: string;
}

interface TeacherInfoProps {
  teachers: TeacherData[];
}

const TeacherInfo: React.FC<TeacherInfoProps> = ({ teachers }) => {
  const navigate = useNavigate();
  const params = useParams<{ academyCode: string }>();
  const academyCode = params.academyCode || '';
  const teacherColumns: ColumnsType<TeacherData> = [
    { title: '순번', dataIndex: 'no', key: 'no', width: 80, align: 'center' },
    { title: '강사명', dataIndex: 'name', key: 'name', width: 120 },
    { title: '강사ID', dataIndex: 'teacherId', key: 'teacherId', width: 120 },
    { title: '생년월일', dataIndex: 'birthDate', key: 'birthDate', width: 120 },
    {
      title: '상태',
      dataIndex: 'status',
      key: 'status',
      width: 100,
      align: 'center',
      render: (status: string) => (
        <Tag color={status === 'normal' ? 'green' : 'red'}>
          {status === 'normal' ? '정상' : '퇴원'}
        </Tag>
      ),
    },
    { title: '등록일', dataIndex: 'registrationDate', key: 'registrationDate', width: 120 },
  ];

  return (
    <div>
      <Table
        columns={teacherColumns}
        dataSource={teachers}
        pagination={{
          total: teachers.length,
          pageSize: 10,
          showSizeChanger: true,
          showQuickJumper: true,
          showTotal: (total, range) => `${range[0]}-${range[1]} / 총 ${total}개`,
        }}
        scroll={{ x: 800 }}
        onRow={(record) => ({
          onClick: () => navigate(`/admin/teacher/${record.teacherId}?from=academy-detail&academyCode=${academyCode}`),
          style: { cursor: 'pointer' }
        })}
      />
    </div>
  );
};

export default TeacherInfo; 